import { render, staticRenderFns } from "./AddReceivingAddress.vue?vue&type=template&id=808bb23a&"
import script from "./AddReceivingAddress.vue?vue&type=script&lang=js&"
export * from "./AddReceivingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports